import { resources, ResourcesList, ResourcesReduxState } from 'redux-and-the-rest';

import { IslandModel } from '../../models/islandModel';
import Env from '../../utils/env';
import { userActions } from './userReducer';

export const ISLANDS_PATH = '/islands';

const {
  reducers: islandsReducer,
  getOrFetchItem: getOrFetchIsland,
  fetchList: fetchIslands,
  fetchItem: fetchIsland,
  getOrFetchList: getOrFetchIslands,
  getNewOrExistingItem: getNewOrExistingIsland,
  createItem: createIsland,
  clearResource: clearIslandResource,
  destroyItem: destroyIsland,
  updateItem: updateIsland,
  newItem: newIsland,
  clearNewItem: clearNewIsland,
} = resources<IslandModel>(
  {
    name: 'islands',
    url: `${Env.API_URL}/current_user${ISLANDS_PATH}/:id?`,
    keyBy: 'id',
    clearOn: [
      userActions.clearItem as string,
    ],
  },
  {
    fetchList: true,
    fetchItem: true,
    createItem: true,
    clearNewItem: true,
    clearResource: true,
    editNewOrExistingItem: true,
    newItem: true,
    destroyItem: true,
    updateItem: true,
  },
);

/**
 * Associated data required for fully rendering an island.
 */
export const ISLAND_INCLUDES = 'theme.gamePositions.game';

/**
 * When fetching islands, we must grab all the associated data required for generating an island.
 * By having it wrapped here, we avoid having to specify the include everywhere we need to fetch the
 * islands.
 */
const wrappedGetOrFetchIslands = (
  islands: ResourcesReduxState<IslandModel>,
): ResourcesList<IslandModel> => getOrFetchIslands(islands, {
  include: ISLAND_INCLUDES,
});

export {
  islandsReducer,
  fetchIslands,
  fetchIsland,
  getOrFetchIsland,
  wrappedGetOrFetchIslands as getOrFetchIslands,
  getNewOrExistingIsland,
  clearIslandResource,
  createIsland,
  destroyIsland,
  updateIsland,
  newIsland,
  clearNewIsland,
};
